import { Component, OnInit } from '@angular/core';
import {GeneralService } from "../services/general.service"
import {DateService } from "../services/date.service"
import {ActionsService} from "../services/actions.service"
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-ressources',
  templateUrl: './ressources.component.html',
  styleUrls: ['./ressources.component.scss']
})
export class RessourcesComponent implements OnInit {

  constructor(public generalService:GeneralService,public route: ActivatedRoute, public actionsService:ActionsService,public dateService:DateService) { }
  titre="Mes ressources"
  type;
  typeTrs;
  param_code = "";
  ngOnInit() 
  {
    this.readParamUrl();
  }
  init()
  {
    if(this.generalService.isNotEmpty(this.generalService.collaborateurConnecter))
    {
      if(this.type == "mes_ressources")
      {
        this.titre = "Mes ressources";
        this.typeTrs = "3";
        this.param_code = this.generalService.collaborateurConnecter;
      }
      else
      {
        this.titre = "Tous les ressources"
        this.typeTrs = "3";
        this.param_code = "";
      }      
    }
    else
    setTimeout(()=>
    {
      this.init()
    },100)
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.type = params['type'];
      this.init()
    });
  }
}
